module.exports = __webpack_public_path__ + "img/action-cam-4.b3e4c916.png";